import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8900e1',
      dark: '#330662',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#702b9d',
          '&:hover': {
            backgroundColor: '#330662',
          },
        },
        textPrimary: {
          color: '#702b9d',
        },
        outlined: {
          borderColor: '#8900e1',
          color: '#8900e1',
          '&:hover': {
            borderColor: '#8900e1',
            color: '#8900e1',
            backgroundColor: 'rgba(51, 6, 98, 0.04)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: '#330662',
          },
          '&:hover fieldset': {
            borderColor: '#8900e1',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#8900e1',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#8900e1',
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottom: '1px solid #330662',
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #8900e1',
          },
          '&:after': {
            borderBottomColor: '#8900e1',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'inherit',
          },
        },
      },
    },
  },
});

export default theme;
